import React, { useState, useEffect } from "react";
import { Button } from "@clarkinc/zest-design-system";

interface Props {
  description: string;
  extendedDescription: string;
  image: string;
  itemNumber: string;
  link: string;
  customMetaHeader: string;
}

const ProductReviewsDescription = ({
  description,
  image,
  itemNumber,
  link,
  customMetaHeader,
}: Props) => {
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 946);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const buttonSize = isLargeScreen ? "large" : "medium";

  return (
    <div className="flex p-6">
      <div className="relative min-w-[80px]">
        <a href={link}>
          <img className="w-[80px] rounded-sm" src={image} alt={description} />
        </a>
      </div>
      <div className="lt:flex items-center lt:justify-between lt:w-full">
        <div className="overflow-hidden px-4 lt:pt-0 max-w-[840px]">
          <h1 className="font-semibold text-xl xs:text-2xl leading-5 xs:leading-6 mb-0">
            <a href={link} className="description" itemProp="name">
              {!customMetaHeader
                ? `Reviews for ${description}`
                : customMetaHeader}
            </a>
          </h1>
          <p className="uppercase text-sm mt-1 mb-2 lt:mb-0">{`Item #: ${itemNumber}`}</p>
        </div>
        <div className="grid lt:place-items-center pl-4 lt:pl-0">
          <a href={link}>
            <Button
              aria-haspopup="true"
              size={buttonSize}
              theme="wss"
              type="button"
              variant="green"
              full
              className="w-auto font-normal whitespace-nowrap"
            >
              Shop This Product
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProductReviewsDescription;
